// src/components/ConfirmExitModal.js
import React from "react";
import { AlertTriangle } from "lucide-react";

/**
 * Modal de confirmación reutilizable
 *
 * Props:
 * - open (bool)
 * - title (string)
 * - message (string)
 * - cancelLabel (string)
 * - confirmLabel (string)
 * - onCancel () => void
 * - onConfirm () => void
 *
 * Accesibilidad:
 * - aria-modal / role="dialog"
 * - aria-labelledby -> título
 */
export default function ConfirmExitModal({
  open,
  title = "¿Salir de la tarea?",
  message = "Si sales ahora, podrías perder tu progreso no enviado.",
  cancelLabel = "Seguir aquí",
  confirmLabel = "Salir",
  onCancel,
  onConfirm,
  confirmDisabled = false,   // 👈 NUEVO
}) {
  if (!open) return null;

  return (
    <div
      className="cxm-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="cxm-title"
    >
      <div className="cxm-card">
        {/* Icono glow */}
        <div className="cxm-iconWrap">
          <div className="cxm-iconAura" />
          <div className="cxm-icon">
            <AlertTriangle size={20} strokeWidth={2.5} />
          </div>
        </div>

        <h2 className="cxm-title" id="cxm-title">
          {title}
        </h2>

        <p className="cxm-msg">{message}</p>

        <div className="cxm-actions">
          <button
            className="rt-btn rt-btn-light cxm-btn-cancel"
            onClick={onCancel}
          >
            {cancelLabel}
          </button>

          <button
            className="rt-btn cxm-btn-confirm"
            onClick={onConfirm}
            disabled={confirmDisabled}   // 👈 NUEVO
            aria-disabled={confirmDisabled}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
